import { camelizeKeys } from 'humps';

const sampleJob = camelizeKeys({
  ret: 'OK',
  data: {
    job_id: 'GX3WjL3ZghA0564B',
    external_job_id: null,
    job_name: 'A+B+C+D',
    user_id: 'jzowJt9gwEZ2iZynalhqMNURpyu2',
    run_status: 'COMPLETED',
    error_message: null,
    task_runner_message: null,
    has_measurements: true,
    has_statevector: true,
    top_128: {
      '00000': 0.00024414079962298274,
      '00001': 0.0009765628492459655,
      '00010': 0.0024414071813225746,
      '00011': 0.004882813431322575,
      '00100': 0.008544924668967724,
      '00101': 0.013671875931322575,
      '00110': 0.02050781436264515,
      '00111': 0.0292968787252903,
      '01000': 0.0393066480755806,
      '01001': 0.0498046912252903,
      '01010': 0.060058604925870895,
      '01011': 0.0693359375,
      '01100': 0.076904296875,
      '01101': 0.08203125,
      '01110': 0.0839843824505806,
      '01111': 0.0820312425494194,
      10000: 0.076904296875,
      10001: 0.0693359375,
      10010: 0.0600585974752903,
      10011: 0.0498046800494194,
      10100: 0.0393066368997097,
      10101: 0.0292968712747097,
      10110: 0.02050781063735485,
      10111: 0.01367187313735485,
      11000: 0.008544921875,
      11001: 0.004882811568677425,
      11010: 0.0024414057843387127,
      11011: 0.0009765622089616954,
      11100: 0.00024414045037701726,
      11101: 2.639197750790921e-15,
      11110: 2.322938729933978e-15,
      11111: 2.5420174489941983e-15,
    },
    device: 'cpu',
    cost: 0,
    estimated_cost: 0,
    cost_per_ms: 0.0001,
    estimated_runtime_ms: 100,
    allowed_runtime_ms: 1000,
    results_path: 'https://storage.googleapis.com/large-job-descriptions-dev/jzowJt9gwEZ2iZynalhqMNURpyu2/GX3WjL3ZghA0564B_',
    num_qubits: 18,
    num_qubits_used: 18,
    qc: {
      device_type: 'cpu',
      qubit_order: [
        'd_5',
        'd_4',
        'd_3',
        'd_2',
        'd_1',
        'd_0',
        'c_4',
        'c_3',
        'c_2',
        'c_1',
        'c_0',
        'b_3',
        'b_2',
        'b_1',
        'b_0',
        'a_2',
        'a_1',
        'a_0',
      ],
      circuit_cirq: '{\n  "cirq_type": "Circuit",\n  "moments": [\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.0625,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.0625,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.03125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.0625,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "a_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.0625,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "b_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.0625,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.0625,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.0625,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_3"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_2"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.0625,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_1"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": 0.03125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "c_0"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.03125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.0625,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "MeasurementGate",\n            "num_qubits": 1,\n            "key": "cd_0",\n            "invert_mask": []\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_0"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.125,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "MeasurementGate",\n            "num_qubits": 1,\n            "key": "cd_1",\n            "invert_mask": []\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_1"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.25,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "MeasurementGate",\n            "num_qubits": 1,\n            "key": "cd_2",\n            "invert_mask": []\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_2"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "CZPowGate",\n            "exponent": -0.5,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            },\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "MeasurementGate",\n            "num_qubits": 1,\n            "key": "cd_3",\n            "invert_mask": []\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_3"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "cirq_type": "Moment",\n      "operations": [\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "HPowGate",\n            "exponent": 1.0,\n            "global_shift": 0.0\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_5"\n            }\n          ]\n        },\n        {\n          "cirq_type": "GateOperation",\n          "gate": {\n            "cirq_type": "MeasurementGate",\n            "num_qubits": 1,\n            "key": "cd_4",\n            "invert_mask": []\n          },\n          "qubits": [\n            {\n              "cirq_type": "NamedQubit",\n              "name": "d_4"\n            }\n          ]\n        }\n      ]\n    }\n  ]\n}',
      circuit_type: 'Qiskit',
      qubit_order_type: 'NamedQubit',
      measurement_indices: [
        1,
        2,
        3,
        4,
        5,
      ],
      reverse_measurement_indices: false,
    },
    qc_unprocessed: {
      circuit: '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',
      circuit_type: 'Qiskit',
    },
    circuit_json: {
      layers: [
        [
          {
            name: 'H',
            qubits: [
              0,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              1,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              2,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              3,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              4,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              5,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              6,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              7,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              8,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              9,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              11,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              12,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              13,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              14,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              17,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              6,
              5,
            ],
            num_controls: 1,
          },
          {
            name: '\u221aCZ',
            qubits: [
              11,
              10,
            ],
            num_controls: 1,
          },
          {
            name: '\u221aCZ',
            qubits: [
              17,
              16,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              5,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              10,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              16,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              6,
              4,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^0.25',
            qubits: [
              11,
              9,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^0.25',
            qubits: [
              17,
              15,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              5,
              4,
            ],
            num_controls: 1,
          },
          {
            name: '\u221aCZ',
            qubits: [
              10,
              9,
            ],
            num_controls: 1,
          },
          {
            name: '\u221aCZ',
            qubits: [
              16,
              15,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.125',
            qubits: [
              6,
              3,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^0.125',
            qubits: [
              11,
              8,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^0.125',
            qubits: [
              17,
              14,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              4,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              9,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              15,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              5,
              3,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^0.25',
            qubits: [
              10,
              8,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^0.25',
            qubits: [
              16,
              14,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.0625',
            qubits: [
              11,
              7,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^0.0625',
            qubits: [
              17,
              13,
            ],
            num_controls: 1,
          },
          {
            name: '\u221aCZ',
            qubits: [
              4,
              3,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              9,
              8,
            ],
            num_controls: 1,
          },
          {
            name: '\u221aCZ',
            qubits: [
              15,
              14,
            ],
            num_controls: 1,
          },
          {
            name: 'H',
            qubits: [
              3,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^0.125',
            qubits: [
              10,
              7,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^0.125',
            qubits: [
              16,
              13,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ',
            qubits: [
              0,
              3,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.03125',
            qubits: [
              17,
              12,
            ],
            num_controls: 1,
          },
          {
            name: 'H',
            qubits: [
              8,
            ],
            num_controls: 0,
          },
          {
            name: '\u221aCZ',
            qubits: [
              0,
              4,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              9,
              7,
            ],
            num_controls: 1,
          },
          {
            name: 'H',
            qubits: [
              14,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              3,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              15,
              13,
            ],
            num_controls: 1,
          },
          {
            name: '\u221aCZ',
            qubits: [
              8,
              7,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^0.25',
            qubits: [
              0,
              5,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.0625',
            qubits: [
              16,
              12,
            ],
            num_controls: 1,
          },
          {
            name: 'H',
            qubits: [
              7,
            ],
            num_controls: 0,
          },
          {
            name: 'CZ',
            qubits: [
              1,
              4,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              14,
              13,
            ],
            num_controls: 1,
          },
          {
            name: '\u221aCZ',
            qubits: [
              1,
              5,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.125',
            qubits: [
              15,
              12,
            ],
            num_controls: 1,
          },
          {
            name: 'CZ^-0.5',
            qubits: [
              4,
              3,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              13,
            ],
            num_controls: 0,
          },
          {
            name: 'CZ',
            qubits: [
              2,
              5,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              14,
              12,
            ],
            num_controls: 1,
          },
          {
            name: 'H',
            qubits: [
              4,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              13,
              12,
            ],
            num_controls: 1,
          },
          {
            name: '\u221aCZ',
            qubits: [
              2,
              6,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              12,
            ],
            num_controls: 0,
          },
          {
            name: 'CZ^-0.25',
            qubits: [
              5,
              3,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              1,
              6,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              5,
              4,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.125',
            qubits: [
              0,
              6,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              5,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^-0.125',
            qubits: [
              6,
              3,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.25',
            qubits: [
              6,
              4,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ',
            qubits: [
              3,
              7,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              6,
              5,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              3,
              8,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              7,
            ],
            num_controls: 0,
          },
          {
            name: 'H',
            qubits: [
              6,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              3,
              9,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ',
            qubits: [
              4,
              8,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.125',
            qubits: [
              3,
              10,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              4,
              9,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              8,
              7,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              4,
              10,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ',
            qubits: [
              5,
              9,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              8,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              5,
              10,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.25',
            qubits: [
              9,
              7,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ',
            qubits: [
              6,
              10,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              9,
              8,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              6,
              11,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              9,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^-0.125',
            qubits: [
              10,
              7,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              5,
              11,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.25',
            qubits: [
              10,
              8,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.125',
            qubits: [
              4,
              11,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              10,
              9,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.0625',
            qubits: [
              3,
              11,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              10,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^-0.0625',
            qubits: [
              11,
              7,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.125',
            qubits: [
              11,
              8,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ',
            qubits: [
              7,
              12,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.25',
            qubits: [
              11,
              9,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              7,
              13,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              12,
            ],
            num_controls: 0,
          },
          {
            name: 'CZ^-0.5',
            qubits: [
              11,
              10,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              7,
              14,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ',
            qubits: [
              8,
              13,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              11,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^0.125',
            qubits: [
              7,
              15,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              8,
              14,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              13,
              12,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.0625',
            qubits: [
              7,
              16,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              8,
              15,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ',
            qubits: [
              9,
              14,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              13,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^0.125',
            qubits: [
              8,
              16,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              9,
              15,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.25',
            qubits: [
              14,
              12,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              9,
              16,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ',
            qubits: [
              10,
              15,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              14,
              13,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              10,
              16,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              14,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^-0.125',
            qubits: [
              15,
              12,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ',
            qubits: [
              11,
              16,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.25',
            qubits: [
              15,
              13,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: '\u221aCZ',
            qubits: [
              11,
              17,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              15,
              14,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.0625',
            qubits: [
              16,
              12,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.25',
            qubits: [
              10,
              17,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              15,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^-0.125',
            qubits: [
              16,
              13,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.125',
            qubits: [
              9,
              17,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.25',
            qubits: [
              16,
              14,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.0625',
            qubits: [
              8,
              17,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              16,
              15,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^0.03125',
            qubits: [
              7,
              17,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              16,
            ],
            num_controls: 0,
          },
        ],
        [
          {
            name: 'CZ^-0.03125',
            qubits: [
              17,
              12,
            ],
            num_controls: 1,
          },
        ],
        [
          {
            name: 'CZ^-0.0625',
            qubits: [
              17,
              13,
            ],
            num_controls: 1,
          },
          {
            name: 'MeasurementGate',
            qubits: [
              12,
            ],
            num_controls: 0,
            parameters_list: [],
          },
        ],
        [
          {
            name: 'CZ^-0.125',
            qubits: [
              17,
              14,
            ],
            num_controls: 1,
          },
          {
            name: 'MeasurementGate',
            qubits: [
              13,
            ],
            num_controls: 0,
            parameters_list: [],
          },
        ],
        [
          {
            name: 'CZ^-0.25',
            qubits: [
              17,
              15,
            ],
            num_controls: 1,
          },
          {
            name: 'MeasurementGate',
            qubits: [
              14,
            ],
            num_controls: 0,
            parameters_list: [],
          },
        ],
        [
          {
            name: 'CZ^-0.5',
            qubits: [
              17,
              16,
            ],
            num_controls: 1,
          },
          {
            name: 'MeasurementGate',
            qubits: [
              15,
            ],
            num_controls: 0,
            parameters_list: [],
          },
        ],
        [
          {
            name: 'H',
            qubits: [
              17,
            ],
            num_controls: 0,
          },
          {
            name: 'MeasurementGate',
            qubits: [
              16,
            ],
            num_controls: 0,
            parameters_list: [],
          },
        ],
      ],
      num_qubits: 18,
    },
    tags: null,
    results_metadata: null,
    queue_start: '2023-01-27T04:08:52.608Z',
    run_start: '2023-01-27T04:08:52.731Z',
    run_end: '2023-01-27T04:08:53.694Z',
    created_on: '2023-01-27T04:08:52.463Z',
    updated_on: '2023-01-27T04:08:54.554Z',
    server_id: 'qsim-task-runner-small-0',
    app_version: '2023-01-26T12:27:18.000Z',
  },
});

export default sampleJob;
